import { SUPPORTED_LOCALES, TRANSLATION_NAMESPACES, type SupportedLocale, type TranslationNamespace } from './config';

type LocaleResource = Record<string, unknown>;
type LocaleResourceModule = {
  default: LocaleResource;
};

const isLocaleResource = (value: unknown): value is LocaleResource => Boolean(value && typeof value === 'object' && !Array.isArray(value));

const isLocaleResourceModule = (value: unknown): value is LocaleResourceModule => {
  if (!value || typeof value !== 'object' || Array.isArray(value) || !('default' in value)) {
    return false;
  }

  return isLocaleResource(value.default);
};

const importLocaleResourceModule = async (language: SupportedLocale, namespace: TranslationNamespace): Promise<unknown> =>
  import(`./locales/${language}/${namespace}.json`);

export const loadLocaleResource = async (language: SupportedLocale, namespace: TranslationNamespace): Promise<LocaleResource> => {
  const localeModule = await importLocaleResourceModule(language, namespace);

  if (!isLocaleResourceModule(localeModule)) {
    throw new Error(`Invalid locale resource module for ${language}/${namespace}`);
  }

  return localeModule.default;
};

export const loadAppLocaleResource = (language: string, namespace: string): Promise<LocaleResource> => {
  if (!SUPPORTED_LOCALES.includes(language as SupportedLocale) || !TRANSLATION_NAMESPACES.includes(namespace as TranslationNamespace)) {
    throw new Error(`Unsupported translation resource: ${language}/${namespace}`);
  }

  return loadLocaleResource(language as SupportedLocale, namespace as TranslationNamespace);
};
